import Modal from '../../components/Modal'
import { convertToRupiah } from '../../helper/Rupiah'

const TYPE_LABELS = {
  consumer: 'Consumer',
  vendor: 'Vendor',
  contractor: 'Kontraktor',
  pelaksana: 'Pelaksana',
}

// Daftar deposit yang ditarik susulan oleh Recalculate (lunas belakangan, belum ada di RMS)
const CatchUpModal = (props) => {
  return (
    <Modal
      activeModal="effect-scale show"
      activeStyle={{ display: 'block', paddingRight: '17px' }}
      modalType="modal-lg"
      title={`${props.data.length} Data Susulan Ditambahkan`}
      closeClick={props.closeModal}
      modalFooter
    >
      <p className="text-start">
        Data ini masuk ke laporan sesuai tanggal order. Periksa kembali laporan periode tersebut.
      </p>
      <div className="table-responsive">
        <table className="table table-bordered text-nowrap mb-0">
          <thead>
            <tr>
              <th>Jenis</th>
              <th>ID Admin Panel</th>
              <th>Klien</th>
              <th>Tgl Deposit</th>
              <th>Deposit</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map((d) => (
              <tr key={`${d.type}-${d.project_id}`}>
                <td>{TYPE_LABELS[d.type] || d.type}</td>
                <td>{d.project_id}</td>
                <td>{d.client_name}</td>
                <td>{d.tgl_deposit}</td>
                <td>Rp. {convertToRupiah(d.deposit || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}

export default CatchUpModal
